import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import ScrollingText from './ScrollingText';
import createDataURL from '../utils/createDataURL';

const SmallSongCard = ({ track }) => {
  const img = track?.album?.images?.[0]?.url || createDataURL('🎵', '#cccccc', '#666666');
  const title = track.name;
  const subtitle = track.artists ? track.artists.map(a => a.name).join(', ') : '';
  const to = `/track/${track.id}`;

  return (
    <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
      <Card
        className="songs-and-top-result-card"
        style={{
          width: '100%',
          height: '60px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: '0.5rem',
          backgroundColor: '#eae9e9ff', // 👈 light grey background
          border: 'none',             // 👈 removes the default border
        }
      }>
        <Card.Img
          className="card-img-top"
          src={img}
          style={{
            width: '60px',
            height: '60px',
            objectFit: 'cover',
            flexShrink: 0
          }}
          onError={(e) => e.target.src = createDataURL('🎵', '#cccccc', '#666666')}
        />
        <Card.Body style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '0.5rem',
          paddingLeft: '0.75rem',
          justifyContent: 'center',
          textAlign: 'left',
          overflow: 'hidden',
          minWidth: 0,
        }}>
          <Card.Title style={{ fontSize: '0.9rem', marginBottom: '0.25rem', minWidth: 0, overflow: 'hidden' }}>
            <ScrollingText>{title}</ScrollingText>
          </Card.Title>
          {subtitle && (
            <Card.Text style={{ fontSize: '0.75rem', color: '#666', marginBottom: 0, minWidth: 0, overflow: 'hidden' }}>
              <ScrollingText>{subtitle}</ScrollingText>
            </Card.Text>
          )}
        </Card.Body>
      </Card>
    </Link>
  );
};

export default SmallSongCard;
